import { render, staticRenderFns } from "./GiftIcon.vue?vue&type=template&id=9b3ccb4a&scoped=true"
import script from "./GiftIcon.vue?vue&type=script&lang=ts"
export * from "./GiftIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b3ccb4a",
  null
  
)

export default component.exports